export default __webpack_public_path__ + "static/media/EuclidFlex-Ultralight.188cb2a2.otf";